import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {NavigationComponent} from "./shared/header-navigation/navigation.component";
import {SidebarComponent} from "./shared/sidebar/sidebar.component";
import {AuthGuard} from "./services/auth.guard";

/*
const appRoutes: Routes = [
  {path:'',loadChildren:'./website/website.module#WebsiteModule'},
  {path:'admin',loadChildren:'./admin/admin.module#AdminModule'}
];*/

const appRoutes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: './purchase/purchase.module#PurchaseModule'
  },
  {
    path: 'authen',
    loadChildren: './authen/authen.module#AuthenModule'
  },
  {
    path: 'po',
    canActivate: [AuthGuard],
    loadChildren: './purchase/purchase.module#PurchaseModule'
  },
  {
    path: 'product',
    canActivate: [AuthGuard],
    loadChildren: './purchase/purchase-product/purchase-product.module#PurchaseProductModule'
  },
  {
    path: 'consignment',
    canActivate: [AuthGuard],
    loadChildren: './consignment/consignment.module#ConsignmentModule'
  },
  {
    path: 'stock-transfer',
    canActivate: [AuthGuard],
    loadChildren: './stock/stock-transfer/stock-transfer.module#StockTransferModule'
  },
  {
    path: 'stock-check',
    canActivate: [AuthGuard],
    loadChildren: './stock/stock-check/stock-check.module#StockCheckModule'
  },
  {
    path: 'receipt',
    canActivate: [AuthGuard],
    loadChildren: './receipt/receipt.module#ReceiptModule'
  },
  {
    path: 'refund',
    canActivate: [AuthGuard],
    loadChildren: './refund/refund.module#RefundModule'
  },
  {
    path: 'payment',
    canActivate: [AuthGuard],
    loadChildren: './payment/payment.module#PaymentModule'
  },
  {
    path: 'user',
    canActivate: [AuthGuard],
    loadChildren: './user/user.module#UserModule'
  },
  {
    path: '',
    component: NavigationComponent,
    outlet: 'navigation'
  }
  , {
    path: '',
    component: SidebarComponent,
    outlet: 'sidebar'
  }
  , {
    path: 'alert',
    loadChildren: './pages/component/alert/alert.module#NgAlertModule'
  }, {
    path: 'carousel',
    loadChildren: './pages/component/carousel/carousel.module#ButtonsModule'
  }, {
    path: 'datepicker',
    loadChildren: './pages/component/datepicker/datepicker.module#DatepickerModule'
  }, {
    path: 'dropdown',
    loadChildren: './pages/component/dropdown-collapse/dropdown-collapse.module#DropdownModule'
  }, {
    path: 'modal',
    loadChildren: './pages/component/modal/modal.module#ModalModule'
  }, {
    path: 'pagination',
    loadChildren: './pages/component/pagination/pagination.module#paginationModule'
  }, {
    path: 'Popovertooltip',
    loadChildren: './pages/component/popover-tooltip/popover-tooltip.module#PopoverTooltipModule'
  }, {
    path: 'progressbar',
    loadChildren: './pages/component/progressbar/progressbar.module#progressbarModule'
  }, {
    path: 'rating',
    loadChildren: './pages/component/rating/rating.module#RatingModule'
  }, {
    path: 'tabs',
    loadChildren: './pages/component/tabs/tabs.module#TabsModule'
  }, {
    path: 'timepicker',
    loadChildren: './pages/component/timepicker/timepicker.module#TimepickerModule'
  }, {
    path: 'typehead',
    loadChildren: './pages/component/typehead/typehead.module#TypeheadModule'
  }, {
    path: 'fontawesome',
    loadChildren: './pages/icons/fontawesome/fontawesome.module#FontawesomeModule'
  }, {
    path: 'simpleline',
    loadChildren: './pages/icons/simpleline/simpleline.module#SimplelineIconModule'
  }, {
    path: 'material',
    loadChildren: './pages/icons/material/material.module#MaterialComponentModule'
  }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// ./src/app/app.routing.ts